import { getCurrencyCode } from '@pegasus/translation';
import { getRecommendationType } from '@pegasus/tracker';
import { PlusBenefitState, PlusBenefitType } from '@pegasus/plus';
import { formatPrice, getGA4Context, getTrackingDiscountedPrice } from '../../helpers';
import { tracker } from '../track';
export const trackRemoveFromCart = (payload, config) => {
    var _a, _b, _c;
    try {
        const { item, isCrossCampaign, isTopPickArticle } = payload;
        tracker.track('GA4-EEC-remove_from_cart', {
            event_name: 'remove_from_cart',
            remove_from_cart: {
                element: 'header',
                currency: getCurrencyCode(config.localeCode.replace('_', '-')),
                value: formatPrice(item.price),
                items: [
                    {
                        item_id: item.configSku,
                        item_name: item.name,
                        affiliation: null,
                        coupon: null,
                        discount: getTrackingDiscountedPrice({
                            specialPriceInCents: (item === null || item === void 0 ? void 0 : item.price) || 0,
                            priceInCents: (item === null || item === void 0 ? void 0 : item.grossRecommendedRetailPrice) || 0,
                            savingsPercent: item.discountPercent || 0,
                            context: 'remove_from_cart',
                        }),
                        index: null,
                        item_brand: item.brandCode,
                        item_list_id: null,
                        item_list_name: getGA4Context({
                            isCrossCampaign,
                            isTopPickArticle,
                        }),
                        item_variant: item.simpleSku,
                        location_id: null,
                        price: formatPrice(item.price),
                        quantity: 1,
                        size_availability: null,
                        item_availability: null,
                        item_info: null,
                        is_sustainable: null,
                        feature_flag: null,
                        product_gender: (item.gender || []).toString() || null,
                        early_access_item: ((_a = item === null || item === void 0 ? void 0 : item.plusBenefit) === null || _a === void 0 ? void 0 : _a.type) === PlusBenefitType.EarlyAccess &&
                            ((_b = item === null || item === void 0 ? void 0 : item.plusBenefit) === null || _b === void 0 ? void 0 : _b.state) === PlusBenefitState.Active
                            ? 1
                            : 0,
                        recommended: getRecommendationType(item.reco),
                        article_size_recommendation: null,
                        product_delivery_dates: `${item.deliveryPromise.beginDate}_${item.deliveryPromise.endDate}`,
                        promotion_id: item.campaignIdentifier,
                        plus_exclusive: ((_c = item === null || item === void 0 ? void 0 : item.plusBenefit) === null || _c === void 0 ? void 0 : _c.type) === PlusBenefitType.Exclusive ? 1 : 0,
                    },
                ],
            },
        });
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('[@browsing/tracker] Tracking `remove_from_cart` failed.', e);
    }
};
